import { render, staticRenderFns } from "./theSidebar.vue?vue&type=template&id=4beb6d7d&scoped=true&"
import script from "./theSidebar.vue?vue&type=script&lang=js&"
export * from "./theSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb6d7d",
  null
  
)

export default component.exports